export default __webpack_public_path__ + "static/media/career-support.ed8ae74e.md";